module.exports = __webpack_public_path__ + "img/bottom.69c9485b.png";